<template>
	<div>
		<div class="crumbs">
		    <el-breadcrumb separator="/">
		        <el-breadcrumb-item>
					 <router-link :to="`/licenseapplys/${activeName}/${pageIndex}`">
						<i class="el-icon-arrow-left" style="cursor: pointer;"></i> 
						牌照查看
					</router-link>
					/ 添加牌照	
		        </el-breadcrumb-item>
		    </el-breadcrumb>
		</div>
		<div class="container">
			<el-form class="addlicense-box" ref="addlicenseform" :model="addlicenseform" :rules="addlicenserules">
				<!-- 新增字段 -->
				<div class="addlicense-item">
					<el-form-item label="地区" prop="areaAddress">
						<el-cascader :options="cityList" :props="optionProps" v-model="addlicenseform.areaAddress" style="width: 100%;"></el-cascader>
						<!-- <el-cascader @change="equipmentCodefun()" :options="cityList" :props="optionProps" v-model="addlicenseform.areaAddress" style="width: 100%;"></el-cascader> -->
					 </el-form-item>
					<el-form-item label="姓名/公司名称" prop="ownerName">
					    <el-input v-model="addlicenseform.ownerName"></el-input>
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="手机号" prop="ownerCellphoneNumber">
					    <el-input v-model="addlicenseform.ownerCellphoneNumber"></el-input>
					</el-form-item>
					<el-form-item label="身份证号/公司代码" prop="ownerIdentityCards">
					    <el-input v-model="addlicenseform.ownerIdentityCards"></el-input>
					</el-form-item>
				</div>
				<div>
					<el-form-item label="性别" prop="ownerSex" style="margin-top: 20px;">
					    <el-radio-group v-model="addlicenseform.ownerSex">
					        <el-radio label="1">男</el-radio>
					        <el-radio label="2">女</el-radio>
					    </el-radio-group>
					</el-form-item>
					
				</div>
				<div class="addlicense-item">
					<el-form-item ref='ownerIdentityCardsPhoto' label="添加身份证正面照/营业执照" prop="ownerIdentityCardsPhoto">
					   <el-upload
						 action="#"
						 list-type="picture-card"
						 :show-file-list="false"
						 :on-change="photoPreviewChange"
						 :http-request="uploadcardsPhotoPreview"
						 :before-upload="beforeAvatarUpload"
					   >
						   <img width="100%" height="100%" v-if="addlicenseform.ownerIdentityCardsPhoto" :src="'/api/static'+addlicenseform.ownerIdentityCardsPhoto" class="avatar">
						   <i v-else class="el-icon-plus"></i>
					   </el-upload>
					   
					</el-form-item>
					<el-form-item ref='ownerIdentityCardsPhotoReverse' label="添加身份证反面照" >
					   <el-upload
						 action="#"
						 list-type="picture-card"
						 :show-file-list="false"
						 :http-request="uploadcardsPhotoReversePreview"
						 :before-upload="beforeAvatarUpload"
					   >
					   <img width="100%" height="100%" v-if="addlicenseform.ownerIdentityCardsPhotoReverse" :src="'/api/static'+addlicenseform.ownerIdentityCardsPhotoReverse" class="avatar">
					   <i v-else class="el-icon-plus"></i>
					   </el-upload>
					  
					</el-form-item>
					
				</div>
				
				
				<div class="addlicense-item">
					<el-form-item label="设备编码" prop="equipmentCode">
					    <el-input @blur="equipmentCodeBlur" v-model="addlicenseform.equipmentCode"></el-input>
					</el-form-item>
					<el-form-item label="整机架号" prop="frameNo">
					    <el-input v-model="addlicenseform.frameNo"></el-input>
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="环保编号" prop="environmentalProtectionNumber">
					    <el-input v-model="addlicenseform.environmentalProtectionNumber"></el-input>
					</el-form-item>
					<el-form-item label="燃油类型" prop="fuelType">
						<el-select v-model="addlicenseform.fuelType" placeholder="请选择燃油类型"  style="width: 100%;">
						    <el-option label="柴油" value="柴油"></el-option>
							<el-option label="汽油" value="汽油"></el-option>
							<el-option label="电动" value="电动"></el-option>
						  </el-select>
					    <!-- <el-input v-model="addlicenseform.fuelType"></el-input> -->
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="排放登记" prop="emissionRegistration">
						<el-select v-model="addlicenseform.emissionRegistration" placeholder="请选择排放登记"  style="width: 100%;">
						    <el-option label="国一" value="国一"></el-option>
							<el-option label="国二" value="国二"></el-option>
							<el-option label="国三" value="国三"></el-option>
							<el-option label="国四" value="国四"></el-option>
							<el-option label="国五" value="国五"></el-option>
							<el-option label="国六" value="国六"></el-option>
							<el-option label="其它" value="其它"></el-option>
						  </el-select>
						
					    <!-- <el-input v-model="addlicenseform.emissionRegistration"></el-input> -->
					</el-form-item>
					<el-form-item label="发动机号" prop="engineNumber">
					    <el-input v-model="addlicenseform.engineNumber"></el-input>
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="发动机功率(KW)" prop="enginePower">
					    <el-input v-model="addlicenseform.enginePower"></el-input>
					</el-form-item>
					<el-form-item label="整机质量(KG)" prop="overallQuality">
					    <el-input v-model="addlicenseform.overallQuality"></el-input>
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="机械品牌" prop="machineryBrand">
					    <el-input v-model="addlicenseform.machineryBrand"></el-input>
					</el-form-item>
					<el-form-item label="出厂日期" prop="productionDateStr">
						<el-date-picker
						      v-model="addlicenseform.productionDateStr"
						      type="date"
							  value-format='yyyy-MM-dd'
						      placeholder="出厂日期">
						</el-date-picker>
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="机械颜色" prop="machineryColor">
					    <el-input v-model="addlicenseform.machineryColor"></el-input>
					</el-form-item>
					<el-form-item label="荷载质量(KG)" prop="nuclearInformation">
					    <el-input v-model="addlicenseform.nuclearInformation"></el-input>
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="机械类型" prop="machineryType">
					    <el-input v-model="addlicenseform.machineryType"></el-input>
					</el-form-item>
					<el-form-item label="生产国别" prop="productionCountry">
						<el-select v-model="addlicenseform.productionCountry" placeholder="请选择生产国别"  style="width: 100%;">
						    <el-option label="中国" value="中国"></el-option>
							<el-option label="日本" value="日本"></el-option>
							<el-option label="韩国" value="韩国"></el-option>
							<el-option label="德国" value="德国"></el-option>
							<el-option label="瑞典" value="瑞典"></el-option>
							<el-option label="美国" value="美国"></el-option>
						  </el-select>
						
					    <!-- <el-input v-model="addlicenseform.productionCountry"></el-input> -->
					</el-form-item>
				</div>
				<div class="addlicense-item">
					<el-form-item label="生产厂家" prop="factory">
					    <el-input v-model="addlicenseform.factory"></el-input>
					</el-form-item>
				</div>
				<div class="addlicense-item license-photo">
					<el-form-item ref='mechanicalPictures' label="添加车辆照片" prop="mechanicalPictures">
						<el-upload
						  action="/api/homepage/uploadImages"
						  list-type="picture-card"
						  :show-file-list="false"
						  :on-success="handleAvatarSuccess"
						  :before-upload="beforeAvatarUpload"
						>
						<img v-if="addlicenseform.mechanicalPictures" :src="'/api/static'+addlicenseform.mechanicalPictures" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
						</el-upload>
					</el-form-item>
				</div>
				
				<div class="addlicense-item">
					<el-form-item label="收货人姓名" prop="shippingName">
					    <el-input v-model="addlicenseform.shippingName"></el-input>
					</el-form-item>
					<el-form-item label="收货人手机号" prop="shippingCellphoneNumber">
					    <el-input v-model="addlicenseform.shippingCellphoneNumber"></el-input>
					</el-form-item>
				</div>
				
				<div class="addlicense-item">
					<el-form-item label="收货人省市县" prop="shippingArea">
						<el-cascader :options="cityxcList" :props="optionxcProps" v-model="addlicenseform.shippingArea" style="width: 100%;"></el-cascader>
					 </el-form-item>
					<el-form-item label="详细地址" prop="shippingDetailedAddress">
					    <el-input v-model="addlicenseform.shippingDetailedAddress"></el-input>
					</el-form-item>
				</div>
				
				<span>
					<el-button type="primary" @click="saveAddlicense('addlicenseform')">确 定</el-button>
					<el-button @click="cancelAddlicense('addlicenseform')">取 消</el-button>
				</span>
			</el-form>
		</div>
		
		 
		 
	 <el-dialog title="图片剪裁" :visible.sync="dialogVisible" append-to-body>
	   <div class="cropper-content">
		 <div class="cropper" style="text-align:center">
		   <vueCropper
			 ref="cropper"
			 :img="option.img"
			 :outputSize="option.outputSize"
			 :outputType="option.outputType"
			 :info="option.info"
			 :canScale="option.canScale"
			 :autoCrop="option.autoCrop"
			 :autoCropWidth="option.autoCropWidth"
			 :autoCropHeight="option.autoCropHeight"
			 :fixed="option.fixed"
			 :fixedBox="option.fixedBox"
			 :fixedNumber="option.fixedNumber"
		   ></vueCropper>
		 </div>
	   </div>
	   <div slot="footer" class="dialog-footer">
		 <el-button @click="dialogVisible = false">取 消</el-button>
		 <el-button type="primary" @click="finish" :loading="loading">确认</el-button>
	   </div>
	 </el-dialog>
		
	</div>
</template>

<script>
	import {VueCropper} from 'vue-cropper'
	import {listProvinceCitys,listProvinceCityCountys,getLicenseNumber,savePcLicenseApply,checkLicenseNumberIsExist} from '@/api/index';
    export default {
        name: 'addlicense',
		components: {
		  VueCropper
		},
        data() {
			var validPhone = (rule, value, callback) => {
						  // debugger
			       const phoneReg = /^[1](([3][0-9])|([4][0,1,4-9])|([5][0-3,5-9])|([6][2,5,6,7])|([7][0-8])|([8][0-9])|([9][0-3,5-9]))[0-9]{8}$/
			       if (!value) {
			         return callback(new Error('电话号码不能为空'))
			       }else if(!Number.isInteger(+value)) {
			           callback(new Error('请输入数字值'))
			       } else {
			           if (phoneReg.test(value)) {
			             callback()
			        } else {
			             callback(new Error('电话号码格式不正确'))
			           }
			         }
			};
			var validIdNum = (rule, value, callback) => {
			  const reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/
			  if (!value) {
			    return callback(new Error('证件号码不能为空'))
			  } else if (!reg.test(value)) {
			    return callback(new Error('证件号码不正确'))
			  } else {
			    callback()
			  }
			};
            return {
				activeName:this.$route.params.activeName,
				pageIndex:this.$route.params.pageIndex,
				cityList:[],//省市数据
				cityxcList:[],
				optionProps: {
					// TODO
						value: 'id',
						label: 'name'
				},   //省市联动重命名指向
				optionxcProps: {
					// TODO
						value: 'name',
						label: 'name'
				},   //省市联动重命名指向
			addlicenseform:{
				areaAddress:[],
				ownerName:'',
				ownerCellphoneNumber:'',
				ownerIdentityCards:'',
				ownerSex:'1',
				ownerIdentityCardsPhoto:'',
				ownerIdentityCardsPhotoReverse:'',
				
			 	equipmentCode:'',
				frameNo:'',
				environmentalProtectionNumber:'',
				fuelType:'柴油',
				emissionRegistration:'国一',
				engineNumber:'',
				enginePower:'',
				overallQuality:'',
				machineryBrand:'',
				productionDateStr:'',
				factory:'',
				machineryColor:'',
				nuclearInformation:'',
				machineryType:'',
				productionCountry:'中国',
				mechanicalPictures:'',
				
				
				shippingName:'',
				shippingCellphoneNumber:'',
				shippingAreaCode:'',
				shippingArea:'',
				shippingDetailedAddress:''
			 },    //添加机构分支表单
			 addlicenserules: {
				 shippingName: [
				 	{ required: true, message: '请输入收货人姓名', trigger:['blur', 'change'] }
				 ],
				 shippingCellphoneNumber: [
				 	{ required: true, trigger: ['blur', 'change'], validator: validPhone }
				 ],
				 shippingArea: [
				 	{required: true, message: '收货人省市县不能为空', trigger:['blur', 'change']}
				 ],
				 shippingDetailedAddress: [
				 	{required: true, message: '收货人详细地址不能为空', trigger:['blur', 'change']}
				 ],
				 
				 areaAddress: [
				 	{type: 'array',required: true, message: '区域不能为空', trigger:['blur', 'change']}
				 ],
				 ownerName: [
				 	{ required: true, message: '请输入姓名', trigger:['blur', 'change'] }
				 ],
				 equipmentCode: [
				 	{ required: true, message: '请输入设备编号', trigger:['blur', 'change'] }
				 ],
				 ownerCellphoneNumber: [
				 	{ required: true, trigger: ['blur', 'change'], validator: validPhone }
				 ],
			 	   ownerIdentityCards: [
			 		 { required: true, message: '请输入身份证号/公司代码', trigger: 'blur' }
			 	   ],
				  ownerIdentityCardsPhoto:[
					  { required: true, message: '请上传身份证正面照', trigger: 'change'}
				  ],
				  ownerIdentityCardsPhotoReverse:[
					   { required: true, message: '请上传身份证反面照', trigger: 'change'}
				  ],
				  mechanicalPictures:[
					  { required: true, message: '请上传车辆照片', trigger: 'change'}
				  ]
				  
			 },  //添加表单验证
				
			 //牌照
			 dialogVisible: false,
			 // 裁剪组件的基础配置option
			 option: {
			   img: '', // 裁剪图片的地址
			   info: true, // 裁剪框的大小信息
			   outputSize: 1, // 裁剪生成图片的质量
			   outputType: 'jpg', // 裁剪生成图片的格式
			   canScale: false, // 图片是否允许滚轮缩放
			   autoCrop: true, // 是否默认生成截图框
			   autoCropWidth: 390, // 默认生成截图框宽度
			   autoCropHeight: 300, // 默认生成截图框高度
			   fixedBox: false, // 固定截图框大小 不允许改变
			   fixed: true, // 是否开启截图框宽高固定比例
			   fixedNumber: [1.3, 1], // 截图框的宽高比例   添加牌照比例   1.3:1   添加操作证书  1:1.5
			   full: true, // 是否输出原图比例的截图
			   canMoveBox: false, // 截图框能否拖动
			   original: false, // 上传图片按照原始比例渲染
			   centerBox: false, // 截图框是否被限制在图片里面
			   infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
			   canMove:true,
			 },
			 // 防止重复提交
			 loading: false,
			 fileinfo:{},
			 
			 
			 
			 picList: [],
			 fileList: [],
			 imgArr:[],
			 hideUpload:false,
		
               
            }
        },
		created() {
			
			var that = this;
			//省市
			listProvinceCitys({
			}).then(res => {
			    // 获取数据成功后的其他操作
				that.cityList = res.data;
			});
			
			
			listProvinceCityCountys({
			}).then(res => {
			    // 获取数据成功后的其他操作
				that.cityxcList = res.data;
			});
		},
        methods: {
			// 设备号
			equipmentCodeBlur(e){
				if(e.target.value){
					// checkLicenseNumberIsExist
					checkLicenseNumberIsExist({
						"licenseNumber": e.target.value
					}).then(res => {
						if(res.code == 1){
							this.$message({
							  message:res.message,
							  type: 'warning'
							});
							this.addlicenseform.equipmentCode = '';
						}
					});
				}
			},
			
			equipmentCodefun(){
				if(this.addlicenseform.areaAddress.length>0){
					var provinceId = this.addlicenseform.areaAddress[0];
					var cityId = this.addlicenseform.areaAddress[1];
					getLicenseNumber({
						'provinceId':provinceId,
						'cityId':cityId
					}).then(res => {
					    // 获取数据成功后的其他操作
						console.log(res.message)
						this.addlicenseform.equipmentCode = res.message;
					});
				}
			},
			//身份证正面照
			photoPreviewChange(file, fileList){
				
			},
			uploadcardsPhotoPreview(item) {
				const _file = item.file;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method:'post',
					headers: { 'Content-Type': 'multipart/form-data' },
					url:"/api/homepage/uploadImages",
					data:formData,
					crossDomain:true,
					cache:false
				}).then(res => {
					this.$refs.ownerIdentityCardsPhoto.clearValidate();
					this.addlicenseform.ownerIdentityCardsPhoto = res.data.data[0];
				}).catch(() => {
				  this.$message.error('上传失败，请重新上传');
				})
				
			},
			//身份证反面照
			uploadcardsPhotoReversePreview(item) {
				const _file = item.file;
				var formData = new FormData();
				formData.append("file", _file);
				this.$http({
					method:'post',
					headers: { 'Content-Type': 'multipart/form-data' },
					url:"/api/homepage/uploadImages",
					data:formData,
					crossDomain:true,
					cache:false
				}).then(res => {
					this.$refs.ownerIdentityCardsPhotoReverse.clearValidate();
					this.addlicenseform.ownerIdentityCardsPhotoReverse = res.data.data[0];
				}).catch(() => {
				  this.$message.error('上传失败，请重新上传');
				})
				
			},
			
			
			
			// 牌照照片
			handleAvatarSuccess(res, file,fileList) {
			 //上传成功后将图片地址赋值给裁剪框显示图片
			 this.$nextTick(() => {
			   this.option.img = URL.createObjectURL(file.raw);
			   this.fileinfo = res
			   this.dialogVisible = true
			 })
			},
			
			beforeAvatarUpload(file) {
			  const isJPG = file.type === 'image/jpeg'
			  const isPng = file.type === 'image/png'
			  const isLt2M = file.size / 1024 / 1024 < 2
	 
			  if (!isJPG && !isPng) {
				this.$message.error('上传图片只能是 JPG或png 格式!')
			  }
			  if (!isLt2M) {
				this.$message.error('上传图片大小不能超过 2MB!')
			  }
			  return (isJPG || isPng) && isLt2M
			},
			finish() {  //截图提交
			  this.$refs.cropper.getCropBlob((data) => {
			    var fileName = 'goods' + this.fileinfo.uid
			    this.loading = true
			    var formData = new FormData();
			    formData.append("file", data);
			    this.$http({
			    	method:'post',
			    	headers: { 'Content-Type': 'multipart/form-data' },
			    	url:"/api/homepage/uploadImages",
			    	data:formData,
			    	crossDomain:true,
			    	cache:false
			    }).then(res => {
					this.dialogVisible = false;
					this.$refs.mechanicalPictures.clearValidate();
					this.addlicenseform.mechanicalPictures = res.data.data[0];
					this.loading = false;
			    }).catch(() => {
			      this.loading = false;
			      this.$message.error('上传失败，请重新上传');
			    })
				
			  })
			},
		
			uploadbtn(){
				console.log(this.picList)
			},
			cancelAddlicense(formName){
				//重置表单数据
				this.$nextTick(()=>{
				  this.$refs.[formName].resetFields();
				});
				this.$router.push(`/licenseapplys/${this.activeName}/${this.pageIndex}`);
			},
			saveAddlicense(formName) {
		let addlicenseform = this.addlicenseform
				let regs = RegExp(/KW|kw|kW|Kw/)
					 if (addlicenseform.enginePower.length >0) {
					  if(regs.test(addlicenseform.enginePower)){
					  }else {
                       this.addlicenseform.enginePower = addlicenseform.enginePower+'KW'
					  }
				  }
				let reg = RegExp(/KG|kg|kG|Kg/)	    
				  if (addlicenseform.overallQuality.length >0) {
					  if(reg.test(addlicenseform.overallQuality)){
					  }else {
                       this.addlicenseform.overallQuality = addlicenseform.overallQuality+'KG'
					  }
				  }
				   if (addlicenseform.nuclearInformation.length > 0) {
					   if(reg.test(addlicenseform.nuclearInformation)){
					  }else {
                       this.addlicenseform.nuclearInformation = addlicenseform.nuclearInformation+'KG'
					  }
				  }

				this.$refs[formName].validate((valid) => {
				  if (valid) {
					  var shippingArea = '';
					  for(var i in this.addlicenseform.shippingArea){
					  	if(i==0){
					  		shippingArea += this.addlicenseform.shippingArea[i];
					  	}else {
					  		shippingArea += '-' + this.addlicenseform.shippingArea[i];
					  	}
					  }
					  this.addlicenseform.shippingArea = shippingArea;
					  // 负责区域字段格式处理
					  this.addlicenseform.areaAddress = JSON.stringify(this.addlicenseform.areaAddress);
					  
					  savePcLicenseApply(this.addlicenseform).then(res => {
						  if(res.code == 0){
							  // 获取数据成功后的其他操作
								this.$message({
								  message: res.message,
								  type: 'success'
								});
								this.$router.push(`/licenseapplys/${this.ativeName}/${this.pageIndex}`);
						  }else if(res.code == 1){
							  this.$message({
							    message: res.message,
							    type: 'warning'
							  });
						  }else{
							  this.$message({
							    message: '报错啦!',
							    type: 'warning'
							  });
						  }
						   
					  });
				  } else {
					return false;
				  }
				});
			  },
			
        },
        computed: {
            
        }
    }

</script>

<style>
	.addlicense-item{
		display: flex;
		display: -webkit-flex;
	}
	.addlicense-item .el-form-item{
		width: 300px;
		margin-right: 50px;
	}
	.addlicense-item .el-form-item__label{
		text-align: left;
		width: 100%;
		margin-bottom: 10px;
	}
	.addlicense-item .el-date-editor.el-input,
	.addlicense-item .el-date-editor.el-input__inner{
		width: 100%;
	}
	.hide .el-upload--picture-card {
	  		display: none;
		}
		
		.cropper-content{
		  width:500px;height:500px;background: pink;
		}
		.cropper{
		  width:500px;
		  height:500px;
		  background: yellow;
		}
		
		
		.license-photo .el-upload--picture-card{
			width: 260px;
			height: 200px;
			line-height: 200px;
		}
		.license-photo .el-upload--picture-card img{
			width: 100%;
			height: 100%;
		}
</style>
